<template>
    <div class="row justify-content-between" id="pagination_container">
        <div class="col col-md-6">
            <div class="row">
                <p :class="extraLabel ? 'col-4' : 'col-8'" v-if="!hideCount">{{totalLabel || $t('Total items')}}: <strong>{{pagination.total}}</strong></p>
                <template v-if="customTotals && !hideCount">
                    <p v-for="(value, key, index) in customTotals" v-bind:key="'custom-total'+index" class="col-12">
                        {{ $t(key) }}: <strong>{{value}}</strong>
                    </p>
                </template>
                <div class="col-8" v-if="extraLabel">{{extraLabel}}: <strong>{{extraAmount}}</strong></div>
            </div>
        </div>
        <div class="w-100 mt-2 d-block d-md-none"></div>
        <div class="col" :class="hideCount ? '' : 'col-md-6'">
            <span class="float-right">
                <b-pagination  class="float-right ml-4" align="right" size="md" :total-rows="pagination.total" :busy="isBusy"
                            v-model="pagination.currentPage"
                            :per-page="pagination.perPage"></b-pagination>
                <b-form-group id="per_page_dropdown" class="float-right" v-if="withChoice">
                    <b-form-select v-model="pagination.perPage">
                        <b-form-select-option :value="10" @click="pagination.perPage = 10">{{selectLabel(10)}}</b-form-select-option>
                        <b-form-select-option :value="20" @click="pagination.perPage = 20">{{selectLabel(20)}}</b-form-select-option>
                        <b-form-select-option :value="50" @click="pagination.perPage = 50">{{selectLabel(50)}}</b-form-select-option>
                        <b-form-select-option :value="100" @click="pagination.perPage = 100">{{selectLabel(100)}}</b-form-select-option>
                    </b-form-select>
                </b-form-group>
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'table-pagination',
        props: ['pagination', 'isBusy', 'totalLabel', 'hideCount', 'withChoice', 'extraLabel', 'extraAmount', 'customTotals'],
        methods: {
            selectLabel(number){
                let final_label = "";
                if(this.pagination.perPage === number)
                    final_label += this.$t('Items per page')+": ";
                final_label += number;
                return final_label;
            }
        }
    }
</script>
<style lang="scss">
    .inline-block{
        display: inline-block;
    }
</style>
